import { render, staticRenderFns } from "./AppColorPicker.vue?vue&type=template&id=50397f79&scoped=true&"
import script from "./AppColorPicker.vue?vue&type=script&lang=ts&"
export * from "./AppColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./AppColorPicker.vue?vue&type=style&index=0&id=50397f79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50397f79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VLayout,VMenu,VTextField})
